import type { SetupIo, SetupMode } from "../install/types.js";

export async function runInstallCommand(argv: string[], io: SetupIo) {
  return await runSetupEntry("install", argv, io);
}

export async function runUpgradeCommand(argv: string[], io: SetupIo) {
  return await runSetupEntry("upgrade", argv, io);
}

async function runSetupEntry(mode: SetupMode, argv: string[], io: SetupIo) {
  const { runSetupCommand } = await import("../install/orchestrator.js");
  return await runSetupCommand(mode, argv, io);
}
